import { render } from "./category-wizard-mobile.vue?vue&type=template&id=4bfc7fb1&scoped=true&ts=true"
import script from "./category-wizard-mobile.vue?vue&type=script&lang=ts"
export * from "./category-wizard-mobile.vue?vue&type=script&lang=ts"

import "./category-wizard-mobile.vue?vue&type=style&index=0&id=4bfc7fb1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfc7fb1"]])

export default __exports__